module.exports = __webpack_public_path__ + "img/image.632f8232.png";